import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateBlockEmployer = {
  blockEmployer: { data: null, loading: false, error: null },
};

export const blockEmployer = createAsyncThunk('user/blockEmployer', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/employers/${data.id}/blocked`,
      { is_blocked: data.is_blocked },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerBlockEmployer = {
  [blockEmployer.pending]: (state) => {
    state.blockEmployer.loading = true;
    state.blockEmployer.error = null;
  },
  [blockEmployer.fulfilled]: (state, action) => {
    state.blockEmployer.loading = false;
    state.blockEmployer.data = true;
    state.blockEmployer.error = null;
  },
  [blockEmployer.rejected]: (state, action) => {
    state.blockEmployer.loading = false;
    state.blockEmployer.error = action.payload;
  },
};
